import Analytics from 'analytics';
import segmentPlugin from '@analytics/segment';

const plugins = [];
if (process.env.SEGMENT_WRITE_KEY) {
  plugins.push(
    segmentPlugin({
      writeKey: process.env.SEGMENT_WRITE_KEY,
    }),
  );
}

export const analytics = Analytics({
  debug: !!process.env.DEBUG,
  plugins,
});
